<div class="container form">

  <mat-card *ngIf="isCollapsed">

    <form [formGroup]="xbrlForm" (ngSubmit)="runreport()">

      <mat-card-content fxLayout="column">

        <mat-form-field fxFlex (click)="startDatePicker.open()">
          <mat-label>Start Date</mat-label>
          <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="startDatePicker" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field fxFlex (click)="endDatePicker.open()">
          <mat-label>End Date</mat-label>
          <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="endDatePicker" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>

      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../']">Cancel</button>
        <button mat-raised-button color="primary" id="runreport">Run Report</button>
      </mat-card-actions>

    </form>

  </mat-card>

</div>

<div class="container">

  <mat-card *ngIf="!isCollapsed">

    <button mat-raised-button color="primary" (click)="isCollapsed = !isCollapsed">
      Parameters
    </button>

    <div class="m-t-20">

      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let entry"> {{ entry.name }} </td>
        </ng-container>

        <ng-container matColumnDef="dimension">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Dimension </th>
          <td mat-cell *matCellDef="let entry"> {{ entry.dimension }} </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Value </th>
          <td mat-cell *matCellDef="let entry"> <input [formControl]="entry.value"></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="select-row"></tr>

      </table>

      <div class="container m-t-20" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px">
        <button type="button" mat-raised-button [routerLink]="['../']">Cancel</button>
        <a [href]="submit()" download="file.xml">
        <button mat-raised-button color="primary">Submit</button>
        </a>
      </div>

    </div>

  </mat-card>

</div>
